import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import { colors } from '../../const/colors'
import { CloseCircle } from './UserDetailsUi'

const UserDetailsHeader: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { t } = useTranslation(['user_details'])

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: '18px 24px',
        background: colors.surface,
        borderBottom: `1px solid ${colors.border}`,
        flexShrink: 0,
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '11px',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: colors.slate,
            fontWeight: 700,
          }}
        >
          {t('eyebrow')}
        </Typography>
        <Typography
          sx={{
            fontSize: '18px',
            fontWeight: 800,
            letterSpacing: '-0.01em',
            mt: '2px',
            color: colors.navy,
          }}
        >
          {t('title')}
        </Typography>
      </Box>
      <CloseCircle onClick={onClose} e2e="close-drawer-button" />
    </Box>
  )
}

export default UserDetailsHeader
